import PropTypes from 'prop-types';
import CruiseListCardHeader from './CruiseListCardHeader';
import CruiseListCardBody from './CruiseListCardBody';
import CruiseListCardFooter from './CruiseListCardFooter';
import './cruiseListCardContent.scss';

const CruiseListCardContent = ({
  content: {
    headerContent,
    bodyContent,
    footerContent,
  },
  href,
  onSelect,
  buttonHref,
  onDistrictClick,
  siteId,
}) => {
  return (
    <div className="iw-cruise-list-card-content-container">
      {headerContent && (
        <CruiseListCardHeader
          headerContent={headerContent}
          href={href}
          onSelect={onSelect}
          onDistrictClick={onDistrictClick}
          siteId={siteId}
        />
      )}
      {bodyContent && (
      <CruiseListCardBody
        bodyContent={bodyContent}
        href={href}
        onSelect={onSelect}
      />
      )}
      {footerContent && (
      <CruiseListCardFooter
        footerContent={footerContent}
        href={href}
        onSelect={onSelect}
        buttonHref={buttonHref}
      />
      )}
    </div>
  );
};

CruiseListCardContent.propTypes = {
  content: PropTypes.shape({
    headerContent: PropTypes.shape({}),
    bodyContent: PropTypes.shape({}),
    footerContent: PropTypes.shape({}),
  }),
  href: PropTypes.string,
  onSelect: PropTypes.func,
  onDistrictClick: PropTypes.func,
  buttonHref: PropTypes.string,
  siteId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

CruiseListCardContent.defaultProps = {
  content: null,
  href: null,
  onSelect: null,
  onDistrictClick: null,
  buttonHref: null,
  siteId: 1,
};

export default CruiseListCardContent;
